/** @module SiteAdmin/Locale/NameRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare,StringRen,locale) {

	return declare(StringRen, {
		/**
		 * @override
		 * Get the localization name rather than the raw code
		 */
		formatValue: function(value, fmt) {
			return locale.resource(value);
		}
	});
});
